<template>
  <main class="c-section c-section--panel-earnings py-2">
    <h1 class="fs-21 w-bold darks mb-4">
      <template v-if="$route.params.teacher_id">
        Ingresos /
        <span v-if="courses.teacher" class="third-color">
          {{courses.teacher.data.display_name}}
        </span>
      </template>
      <template v-else>
        Mis ingresos
      </template>
    </h1>

    <div class="c-reports-header d-flex mb-4">
      <div class="c-reports-header__date c-form">
        <date-picker
          class="c-form__date w-100 tiny"
          v-model="month"
          valueType="format"
          type="month"
          placeholder="Seleccionar fechas"
          @change="getCourseErnings()"
        >
        </date-picker>
      </div>
    </div>

    <div class="darks w-sbold mb-4">
      Mes: <span class="w-bold third-color">{{parsedMonth}}</span>
    </div>

    <div class="c-panel">
      <aside>
        <div class="c-panel__summary">
          <div class="row gy-4">
            <div class="col-12">
              <div class="bg-white p-3 br--small">
                <b-skeleton-wrapper :loading="courses.loading">
                  <template #loading>
                    <h2 class="fs-18 w-bold darks mb-3">Ingresos totales</h2>
                    <b-skeleton
                      type="text"
                      height="40px"
                      class="light"
                    >
                    </b-skeleton>
                    <b-skeleton
                      type="text"
                      width="80%"
                      class="light"
                    >
                    </b-skeleton>
                  </template>

                  <template v-if="courses.summary">
                    <h2 class="fs-18 w-bold darks mb-3">Ingresos totales</h2>
                    <p
                      class="fs-30 w-bold mb-0"
                      :class="(courses.summary.sales + courses.summary.subscriptions)
                        ? 'pri-color' : 'medium-gray'
                      "
                    >
                      ${{(courses.summary.sales + courses.summary.subscriptions).toFixed(2)}}
                    </p>
                    <p class="fs-16 w-medium mb-0 dark-gray">Monto en dólares</p>
                  </template>
                </b-skeleton-wrapper>
              </div>
            </div>
            <div class="col-12">
              <div class="bg-white p-3 br--small">
                <b-skeleton-wrapper :loading="courses.loading">
                  <template #loading>
                    <h2 class="fs-18 w-bold darks mb-3">Ingresos por ventas</h2>
                    <b-skeleton
                      type="text"
                      height="40px"
                      class="light"
                    >
                    </b-skeleton>
                    <b-skeleton
                      type="text"
                      width="80%"
                      class="light"
                    >
                    </b-skeleton>
                  </template>

                  <template v-if="courses.summary">
                    <h2 class="fs-18 w-bold darks mb-3">Ingresos por ventas</h2>
                    <p
                      class="fs-30 w-bold mb-0"
                      :class="(courses.summary.sales) ? 'pri-color' : 'medium-gray'"
                    >
                      ${{courses.summary.sales.toFixed(2)}}
                    </p>
                    <p class="fs-16 w-medium mb-0 dark-gray">Monto en dólares</p>
                  </template>
                </b-skeleton-wrapper>
              </div>
            </div>
            <div class="col-12">
              <div class="bg-white p-3 br--small">
                <b-skeleton-wrapper :loading="courses.loading">
                  <template #loading>
                    <h2 class="fs-18 w-bold darks mb-3">Ingresos por suscripciones</h2>
                    <b-skeleton
                      type="text"
                      height="40px"
                      class="light"
                    >
                    </b-skeleton>
                    <b-skeleton
                      type="text"
                      width="80%"
                      class="light"
                    >
                    </b-skeleton>
                  </template>

                  <template v-if="courses.summary">
                    <h2 class="fs-18 w-bold darks mb-3">Ingresos por suscripciones</h2>
                    <p
                      class="fs-30 w-bold mb-0"
                      :class="(courses.summary.subscriptions) ? 'pri-color' : 'medium-gray'"
                    >
                      ${{courses.summary.subscriptions.toFixed(2)}}
                    </p>

                    <p
                      class="fs-14 w-medium mb-2 dark-gray w-medium
                        d-flex align-items-start"
                    >
                      <Icon icon="mdi:clock-time-three-outline" class="fs-18 me-1" />
                      {{courses.summary.time_watched}} minutos reproducidos
                    </p>
                    <p
                      v-if="false"
                      class="fs-14 w-medium mb-2 dark-gray w-medium
                        d-flex align-items-start"
                    >
                      <Icon icon="la:coins" class="fs-18 me-1" />
                      {{courses.summary.month_fee}} pago aproximado por minuto
                    </p>

                    <p class="fs-16 w-medium mb-0 dark-gray">Monto en dólares</p>
                  </template>
                </b-skeleton-wrapper>
              </div>
            </div>
          </div>
        </div>
      </aside>
      <div class="c-panel__reports flex-grow-1 bg-white p-3 br--small">
        <h2 class="mb-4 fs-18 w-bold darks">Ingresos por curso</h2>

        <b-skeleton-wrapper :loading="courses.loading" class="mb-4">
          <template #loading>
            <div class="row gy-4">
              <div
                v-for="cs of [1,2,3,4,5]"
                :key="`course-sk-${cs}`"
                class="col-12"
              >
                <article
                  class="c-course-report-card bg-white p-3 br--small ax-shadow ax-shadow--medium"
                >
                  <figure
                    class="c-course-report-card__thumbnail d-none
                      d-md-block d-lg-none d-xl-block me-3"
                  >
                    <b-skeleton-img variant="skeleton-light" aspect="16:9"></b-skeleton-img>
                  </figure>
                  <div class="flex-grow-1">
                    <h3 class="c-course-report-card__title fs-16 w-sbold darks mb-2 w-100">
                      <b-skeleton class="light" type="text" width="100%" height="20px"></b-skeleton>
                    </h3>
                    <ul class="ul-reset">
                      <li class="mb-1">
                        <b-skeleton
                          class="light"
                          type="text"
                          width="100%"
                          height="10px"
                        ></b-skeleton>
                      </li>
                      <li>
                        <b-skeleton
                          class="light"
                          type="text"
                          width="100%"
                          height="10px"
                        ></b-skeleton>
                      </li>
                    </ul>
                  </div>
                </article>
              </div>
            </div>
          </template>

          <div v-if="!courses.data" class="bg-white p-3 br--small">
            <h2 class="fs-18 w-bold darks mb-4">Ingresos por curso</h2>

            <div class="d-flex flex-column text-center">
              <figure class="c-empty-image mb-4">
                <img
                  class="w-100 h-100 of--contain"
                  src="@/assets/images/lection/homework/no-completed.png"
                  alt="Arcux - Not found"
                >
              </figure>
              <p class="dark-gray mb-0">Aun no cuentas con algun curso</p>
            </div>
          </div>
          <div v-else class="row gy-4">
            <div
              v-for="course of courses.data"
              :key="`course-${course.ID}`"
              class="col-12"
            >
              <article
                class="c-course-report-card bg-white p-3 br--small ax-shadow ax-shadow--medium"
              >
                <figure
                  class="c-course-report-card__thumbnail d-none d-md-block
                    d-lg-none d-xl-block me-3"
                >
                  <img
                    class="w-100"
                    :src="course.thumbnail"
                    alt=""
                  />
                </figure>
                <div class="flex-grow-1">
                  <h3 class="c-course-report-card__title fs-16 w-sbold darks mb-2">
                    <span>{{course.post_title}}</span>
                    <span>${{course.total.toFixed(2)}}</span>
                  </h3>
                  <ul class="ul-reset fs-14">
                    <li class="d-flex justify-content-between mb-1">
                      <p class="mb-0 d-flex align-items-center">
                        <Icon icon="la:money-bill-wave" class="me-1" />
                        {{course.sales.total}} ventas
                      </p>
                      <span>${{course.sales.amount.toFixed(2)}}</span>
                    </li>
                    <li class="d-flex justify-content-between">
                      <p class="mb-0 d-flex align-items-center">
                        <Icon icon="mdi:clock-time-three-outline" class="me-1" />
                        {{course.time_watched.total}} minutos reproducidos
                      </p>
                      <span>${{course.time_watched.amount.toFixed(2)}}</span>
                    </li>
                  </ul>
                </div>
              </article>
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>
    </div>
  </main>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/es';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      arcux: { ...window.arcux },

      month: '',

      courses: {
        summary: null,
        teacher: null,
        data: [],
        loading: true,
      },
    };
  },
  components: { DatePicker },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),

    teacherId() {
      return (this.$route.params.teacher_id)
        ? this.$route.params.teacher_id
        : this.userData.id;
    },

    dates() {
      const year = this.month.split('-') ? this.month.split('-')[0] : '0';
      const month = this.month.split('-') ? this.month.split('-')[1] : '0';

      const lastDay = new Date(year, (month - 1) + 1, 0).getDate();

      return [
        `${this.month}-01`,
        `${this.month}-${lastDay}`,
      ];
    },

    parsedMonth() {
      const month = this.month.split('-') ? this.month.split('-')[1] : '0';
      let monthName = '';

      switch (month) {
        case '01':
          monthName = 'Enero';
          break;

        case '02':
          monthName = 'Febrero';
          break;

        case '03':
          monthName = 'Marzo';
          break;

        case '04':
          monthName = 'Abril';
          break;

        case '05':
          monthName = 'Mayo';
          break;

        case '06':
          monthName = 'Junio';
          break;

        case '07':
          monthName = 'Julio';
          break;

        case '08':
          monthName = 'Agosto';
          break;

        case '09':
          monthName = 'Setiembre';
          break;

        case '10':
          monthName = 'Octubre';
          break;

        case '11':
          monthName = 'Noviembre';
          break;

        case '12':
          monthName = 'Diciembre';
          break;

        default:
          monthName = '';
          break;
      }

      return monthName;
    },
  },
  mounted() {
    this.initMonth();
    this.getCourseErnings();
  },
  methods: {
    initMonth() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth();

      const formatedMonth = month + 1 > 10 ? month + 1 : `0${month + 1}`;

      this.month = `${year}-${formatedMonth}`;
    },
    getCourseErnings() {
      this.courses.loading = true;

      const dates = this.dates.length ? `?datesBetween=${this.dates.join(',')}` : '';
      const requestURL = `${process.env.VUE_APP_SITE}/api/v1/users/${this.teacherId}/profile/earnings${dates}`;

      fetch(requestURL, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.courses.data = response.data.courses;
            this.courses.summary = response.data.summary;
            this.courses.teacher = response.data.teacher;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.courses.loading = false;
        });
    },
  },
};
</script>
